export default {
	iphone: 415,
	sm: 640,
	sl: 768,
	md: 1024,
	lg: 1280,
	xl: 1520,
};
